import { Box, Radio } from '@mui/material';
import React from 'react';

const iconSx = {
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 20,
  height: 20,
  backgroundColor: theme => theme.palette.white,
  border: theme => `1px solid ${theme.palette.secondary.light}`,
  'input:hover ~ &': {
    borderColor: 'primary.light2',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background: theme => theme.palette.greyBlue,
  },
};

const checkedIconSx = {
  ...iconSx,
  '&:before': {
    backgroundColor: 'primary.main',
    borderRadius: '50%',
    display: 'block',
    width: 10,
    height: 10,
    content: '""',
  },
};

const StyledRadio = props => (
  <Radio
    sx={{
      '&:hover': {
        backgroundColor: 'transparent',
      },
    }}
    color="default"
    checkedIcon={<Box component="span" sx={checkedIconSx} />}
    icon={<Box component="span" sx={iconSx} />}
    {...props}
  />
);

export default StyledRadio;
